import { react as Elevio, client as elevioClient } from 'elevio';
import { config } from 'lib-shared-backend-config';
import { useEffect, useState } from 'react';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

export const ElevioClient = (): JSX.Element => {
  const { useBirdeatsbug } = useFeatureFlag(['use-birdeatsbug']);
  const [isElevioReady, setIsElevioReady] = useState(false);

  // Temp fix until the birdeatsbug goes into GA.
  // Hide the Elevio Module (id 47) record button in the Elevio Assistant.
  // https://api-docs.elevio.help/en/articles/58
  useEffect(() => {
    window._elev.on('ready', function (_elev) {
      setIsElevioReady(true);
    });
    if (useBirdeatsbug === false && isElevioReady === true) {
      elevioClient.hideModules([47]);
    }
  }, [isElevioReady, useBirdeatsbug]);

  return (
    <Elevio accountId={config.sdk.elevio} settings={{ hideLauncher: true }} />
  );
};
